var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7862 5.91263C9.7862 8.1733 7.95357 10.0059 5.69291 10.0059C3.43224 10.0059 1.59961 8.1733 1.59961 5.91263C1.59961 3.65197 3.43224 1.81934 5.69291 1.81934C7.95357 1.81934 9.7862 3.65197 9.7862 5.91263ZM9.32523 10.1661C8.34795 11.0015 7.07934 11.5059 5.69291 11.5059C2.60381 11.5059 0.0996094 9.00173 0.0996094 5.91263C0.0996094 2.82354 2.60381 0.319336 5.69291 0.319336C8.782 0.319336 11.2862 2.82354 11.2862 5.91263C11.2862 7.07579 10.9312 8.15603 10.3235 9.05087C10.3471 9.06936 10.3698 9.08946 10.3915 9.11117L13.6809 12.4006C13.9738 12.6935 13.9738 13.1684 13.6809 13.4612C13.388 13.7541 12.9132 13.7541 12.6203 13.4612L9.33085 10.1718C9.32896 10.1699 9.32709 10.168 9.32523 10.1661Z",
    fill: "#01032C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9a4cc60cc042e731b28ed6a1f3afc85a.svg";
export { ForwardRef as ReactComponent };